const animations = require('./animations');

const header = () => {

    $(".header-menu .navbar-toggler-icon").click(function () {
        $(".header-menu .menu").fadeToggle();
        animations();
    });

    $(window).on("scroll", function () {
        const $header = $(".header-menu");
        if (!$header.length) return;

        const isOnTop = $(window).scrollTop() >= $header.offset().top;
        if (isOnTop) $header.addClass("fixed")
        else $header.removeClass("fixed")
    });
    $(".header-menu .nav-item").on("mouseover", function () {
        $(".header-menu .nav-item").find(".red-circle").css("visibility", "hidden");
        $(this).find(".red-circle").css("visibility", "visible");
    });
    $(".header-menu .nav-item").on("mouseout", function () {
        $(this).find(".red-circle").css("visibility", "hidden");
        $(".header-menu .nav-item.active .red-circle").css("visibility", "visible");
    });
}

module.exports = header
